import { useCallback, useEffect } from 'react';
import { useSmartWallet } from '@package/smart-wallet/providers';
import * as Sentry from '@sentry/react';

type ConnectProps =
  | {
      onSuccess: VoidFunction;
    }
  | undefined;

export const useConnectWallet = (props?: ConnectProps) => {
  const { login, isLoading, isConnected } = useSmartWallet();

  /* Callbacks */
  const handleConnect = useCallback(() => {
    try {
      if (isLoading || isConnected) return;
      login();
    } catch (error) {
      console.error('Error connecting: ', error);
      Sentry.captureException({
        message: 'Error connecting',
        extra: {
          error,
        },
      });
    }
  }, [isLoading, isConnected, login]);

  /* Effects */
  useEffect(() => {
    if (!isLoading && isConnected && props?.onSuccess) {
      props?.onSuccess?.();
    }
  }, [props, isConnected, isLoading]);

  /* Return */
  return { handleConnect, isLoading, isConnected };
};
